export const getPopupContentStyle = (isMobile: boolean): Record<string, string> => ({
  width: '100%',
  height: isMobile ? '100%' : 'auto',
  padding: isMobile ? '1.5rem 0 2.25rem' : '1.5rem 0.6rem 2.25rem',
  maxHeight: window.matchMedia('(orientation: landscape)').matches ? '95vh' : '100vh',
  overflow: 'auto',
});
